export const auctionDeliveryMethodDisplayValues = {
  0: '',
  1: 'form.field.delivery',
  2: 'form.field.pick_up',
  3: 'form.field.delivery_and_pick_up',
};
